import script from "./inputDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./inputDialog.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__